<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{msg}}</p>
</div>
